import React from "react";
import { FaBullhorn, FaGlobe, FaGoogle, FaMapMarkerAlt, FaFacebook, FaInstagram, FaTiktok, FaYoutube, FaCamera, FaPencilRuler, FaVideo, FaBuilding, FaTags, FaEnvelope } from "react-icons/fa";
import "./OurExpertise.css";

const EXPERTISE = [
  { icon: <FaBullhorn />, title: "Digital Marketing", desc: "Complete online marketing solutions." },
  { icon: <FaGlobe />, title: "Websites / SEO", desc: "Modern, responsive websites & top Google rankings." },
  { icon: <FaGoogle />, title: "Google Ads (PPC)", desc: "Pay-per-click campaigns that bring instant leads." },
  { icon: <FaMapMarkerAlt />, title: "Google My Business", desc: "Optimize your local business presence." },
  { icon: <FaFacebook />, title: "Facebook Ads", desc: "Creative, data-driven campaigns to grow your brand." },
  { icon: <FaInstagram />, title: "Instagram Ads", desc: "Eye-catching ads to attract and engage followers." },
  { icon: <FaTiktok />, title: "TikTok Ads", desc: "Viral video ads for a younger, active audience." },
  { icon: <FaYoutube />, title: "YouTube Ads", desc: "Video campaigns for massive brand awareness." },
  { icon: <FaCamera />, title: "Posts, Reels, Stories", desc: "Consistent social content to build trust." },
  { icon: <FaPencilRuler />, title: "Design Services", desc: "Graphics that make your brand stand out." },
  { icon: <FaVideo />, title: "Video Ad Campaigns", desc: "Professional video creation & marketing." },
  { icon: <FaBuilding />, title: "Company Profile", desc: "Compelling company profiles that impress." },
  { icon: <FaTags />, title: "Products Branding", desc: "Innovative branding to make your products unforgettable." },
  { icon: <FaEnvelope />, title: "E-Mail Marketing", desc: "Targeted campaigns to nurture leads." },
];

export default function OurExpertise() {
  return (
    <section className="expertise" id="expertise">
      <div className="expertise__inner">
        <h2 className="expertise__title">Our Expertise</h2>
        <p className="expertise__subtitle">
          We offer 14 powerful services tailored for every business.
        </p>
        <div className="expertise__grid">
          {EXPERTISE.map((item, index) => (
            <div className="expertise-card" key={index}>
              <span className="expertise-icon">{item.icon}</span>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
